const PrintControl = (props) => {

  const printMap = () => {
    props.setActiveWidget("");
    const map = document.querySelector(".map");
    if (!map) return;

    const PX_TO_MM = 25.4 / 96;

    const mapWidthPx = map.offsetWidth;
    const mapHeightPx = map.offsetHeight;

    const mapWidthMm = mapWidthPx * PX_TO_MM;
    const mapHeightMm = mapHeightPx * PX_TO_MM;

    const oldStyle = document.getElementById("print-style");
    if (oldStyle) oldStyle.remove();

    const style = document.createElement("style");
    style.id = "print-style";
    style.textContent = `
      @media print {
        @page {
          size: ${mapWidthMm}mm ${mapHeightMm}mm;
          margin: 0;
        }

        body {
          margin: 0;
          padding: 0;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .map {
          width: ${mapWidthPx}px !important;
          height: ${mapHeightPx}px !important;
          transform: none !important;
        }
      }
    `;
    document.head.appendChild(style);
  
    setTimeout(() => {
      window.print();
    }, 200);
  };

  return (
    <>
      <button className="ccl-button ccl-button--default ccl-button--default-neg map-button" onClick={() => printMap()} aria-label="Print">
        <i className="fa-solid fa-print"></i>
      </button>
    </>
  );
}

export default PrintControl;
